<div [ngClass]="{'monitor': section}">
    <ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
        [disabled]="ngxDisabled" [autoClearSearch]="false" [(ngModel)]="marginType" placeholder="Seleccionar Margen"
        (select)="changeMarginType($event)">
        <ng-template ngx-select-option-not-found let-input>
            "{{input}}" no encontrado
        </ng-template>
    </ngx-select>
</div>